import { motion } from "framer-motion";

// 6 páginas cuidadosamente escolhidas — 3 capas de capítulo com imagens fortes
// + 2 páginas de exercício + 1 pausa com pensamento
const pages = [
  { src: "/workbook/full_p29.jpg", caption: "Capítulo VII · Clareza não é certeza" }, // borboleta laranja
  { src: "/workbook/full_p07.jpg", caption: "Exercício · O que te trouxe a esta página" }, // exercício
  { src: "/workbook/full_p33.jpg", caption: "Capítulo VIII · Dois tipos de decisão" }, // estrada costeira
  { src: "/workbook/full_p37.jpg", caption: "Pausa · O silêncio já tem a resposta" }, // luar / pausa
  { src: "/workbook/full_p15.jpg", caption: "Exercício · O inventário do que carregas" }, // exercício
  { src: "/workbook/full_p25.jpg", caption: "Capítulo VI · O medo por trás da decisão" }, // paisagem minimalista
];

export default function SamplePages() {
  // duplicar para preencher o marquee
  const stream = [...pages, ...pages, ...pages];

  return (
    <section
      id="paginas"
      data-testid="sample-pages-section"
      className="py-24 md:py-36 bg-cream-soft relative overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 mb-14">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-12"
        >
          <div className="md:col-span-3">
            <span className="section-num">05 · Páginas</span>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.02] mb-6">
              Uma amostra.
              <br />
              <span className="font-serif-display text-orange normal-case lowercase">antes de começares a viagem.</span>
            </h2>
            <p className="text-lg text-ink-soft max-w-2xl leading-relaxed">
              Algumas páginas cuidadosamente escolhidas — não o livro inteiro.
              Para teres uma noção da forma e do tom, e o conteúdo continuar a
              ser uma descoberta tua, ao teu ritmo.
            </p>
          </div>
        </motion.div>
      </div>

      <div className="absolute left-0 top-32 bottom-0 w-20 md:w-32 bg-gradient-to-r from-[#FBF7F0] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-32 bottom-0 w-20 md:w-32 bg-gradient-to-l from-[#FBF7F0] to-transparent z-10 pointer-events-none" />

      <motion.div
        className="flex gap-6 md:gap-10 pl-6 md:pl-12"
        animate={{ x: ["0%", "-33.333%"] }}
        transition={{ duration: 55, repeat: Infinity, ease: "linear" }}
      >
        {stream.map((p, i) => {
          const idx = i % pages.length;
          return (
            <figure
              key={i}
              data-testid={`sample-page-${idx}`}
              className="flex-shrink-0 w-[220px] sm:w-[270px] md:w-[310px]"
            >
              <div
                className="aspect-[1240/1755] bg-white border border-line overflow-hidden"
                style={{ filter: "drop-shadow(0 18px 32px rgba(31,29,27,0.12))" }}
              >
                <img
                  src={p.src}
                  alt={p.caption}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <figcaption className="mt-4 smallcaps text-center">
                {p.caption}
              </figcaption>
            </figure>
          );
        })}
      </motion.div>
    </section>
  );
}
